<template>
    <div class="well-graphical-segmentations">
        <canvas ref="canvas" class="w-100 h-100" />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Theme from '../../business/utils/Theme'

export default {
    name: 'WellGraphicalSegmentations',
    props: {
        segmentations: {
            type: Array,
            required: true
        },
        currentRunIndex: {
            type: Number,
            required: true
        },
        alwaysShow: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            segmentationCanvasParams: {
                pn: {
                    color: Theme.segmentationsColors.green,
                    fillColor: Theme.segmentationsColors.green + '44',
                    lineWidth: 1.5
                },
                icm: {
                    color: Theme.segmentationsColors.lightGreen,
                    fillColor: Theme.segmentationsColors.lightGreen + '44',
                    lineWidth: 1.5
                },
                te: {
                    color: Theme.segmentationsColors.purple,
                    fillColor: Theme.segmentationsColors.purple + '44',
                    lineWidth: 1.5
                }
            }
        }
    },
    computed: {
        ...mapState({
            showAnnotationGraphics: state => state.timelapse.showAnnotationGraphics
        }),
        runSegmentations() {
            return this.segmentations[this.currentRunIndex]
        },
        shouldShow() {
            return this.alwaysShow || this.showAnnotationGraphics
        }
    },
    watch: {
        showAnnotationGraphics() {
            this.draw()
        },
        currentRunIndex() {
            this.draw()
        },
        alwaysShow: {
            handler: function () {
                this.$nextTick(() => {
                    this.draw()
                })
            },
            immediate: true
        }
    },
    mounted() {
        const canvas = this.$refs.canvas

        canvas.width = 512
        canvas.height = 512
    },
    methods: {
        draw() {
            const canvas = this.$refs.canvas
            if (!canvas) return

            const ctx = canvas.getContext('2d')
            ctx.clearRect(0, 0, canvas.width, canvas.height)

            if (!this.shouldShow || !this.runSegmentations) return

            ctx.beginPath()

            for (const key in this.runSegmentations) {
                const annotationCanvasParam = this.segmentationCanvasParams[key]
                const runSegmentation = this.runSegmentations[key]

                runSegmentation.forEach(segmentation => {
                    ctx.strokeStyle = annotationCanvasParam.color
                    ctx.fillStyle = annotationCanvasParam.fillColor
                    ctx.lineWidth = annotationCanvasParam.lineWidth

                    for (let i = 0; i < segmentation.length; i++) {
                        const point = segmentation[i]

                        const calibratedX = point[0] * canvas.width
                        const calibratedY = point[1] * canvas.height

                        if (i === 0) {
                            ctx.moveTo(calibratedX, calibratedY)
                        } else {
                            ctx.lineTo(calibratedX, calibratedY)
                        }
                    }

                    ctx.closePath()
                })
            }

            ctx.fill()
            ctx.stroke()
        }
    }
}
</script>

<style lang="scss" scoped>
.well-graphical-segmentations {
    position: absolute;
    top: 0;
    opacity: 0.8;
    transform-origin: 0 0;
    pointer-events: none;
}
</style>
